import Raven from 'raven-js';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { CMS_HUB_ENTERPRISE, CMS_HUB_PROFESSIONAL, CORE_SEATS_ENTERPRISE, CORE_SEATS_PROFESSIONAL, CRM_SUITE_ENTERPRISE_BUNDLE, CRM_SUITE_PROFESSIONAL_BUNDLE, CRM_SUITE_STARTER_BUNDLE, MARKETING_HUB_ENTERPRISE, MARKETING_HUB_PROFESSIONAL, OPERATIONS_HUB_ENTERPRISE, OPERATIONS_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
const VALID_API_NAMES_FOR_CORE_SEAT = [MARKETING_HUB_PROFESSIONAL, MARKETING_HUB_ENTERPRISE, OPERATIONS_HUB_PROFESSIONAL, OPERATIONS_HUB_ENTERPRISE, CMS_HUB_PROFESSIONAL, CMS_HUB_ENTERPRISE, CRM_SUITE_STARTER_BUNDLE, CRM_SUITE_PROFESSIONAL_BUNDLE, CRM_SUITE_ENTERPRISE_BUNDLE, CORE_SEATS_PROFESSIONAL, CORE_SEATS_ENTERPRISE];
const SELECTABLE_SEAT_TYPES = ['core', 'sales', 'service', 'commerce'];
const isValidApiNameForCoreSeat = apiName => VALID_API_NAMES_FOR_CORE_SEAT.some(validName => validName === apiName);
const createOwnedProductString = parsedProducts => {
  const translatedProducts = [];
  for (const product of parsedProducts) {
    const productLanguageKey = `purchaseMotions.products.${product}`;
    if (isValidI18nKey(productLanguageKey)) {
      translatedProducts.push(I18n.text(productLanguageKey));
    }
  }
  return translatedProducts.join(', ');
};
export const getOwnedProductsThatRequireCoreSeat = products => {
  return (products === null || products === void 0 ? void 0 : products.map(product => product.productApiName).filter(isValidApiNameForCoreSeat)) || [];
};
const formatSeatLevel = tierName => {
  const seatLevelKey = `purchaseMotions.requestSeat.modal.seatInputSelect.tier.${tierName === 'pro' ? 'professional' : tierName}`;
  return isValidI18nKey(seatLevelKey) ? I18n.text(seatLevelKey) : '';
};
export const getSeatSelectOptions = (seatInfoResponse, ownedProductsThatRequireCoreSeat) => {
  const seatSelectOptions = [];
  for (const seatInfo of seatInfoResponse) {
    const [seatType, tier] = seatInfo.seatName.split('-');
    if (seatInfo.maxAssignableSeats && seatInfo.maxAssignableSeats > 0 && SELECTABLE_SEAT_TYPES.includes(seatType)) {
      const seatTypeTitleKey = `purchaseMotions.requestSeat.modal.seatInputSelect.${seatType}.title`;
      let seatTypeSubtitleKey = '';
      if (seatType === 'core' && ownedProductsThatRequireCoreSeat.length === 0) {
        seatTypeSubtitleKey = `purchaseMotions.requestSeat.modal.seatInputSelect.core.fallbackSubtitle`;
      } else {
        seatTypeSubtitleKey = `purchaseMotions.requestSeat.modal.seatInputSelect.${seatType}.subtitle`;
      }
      if (isValidI18nKey(seatTypeTitleKey) && isValidI18nKey(seatTypeSubtitleKey)) {
        seatSelectOptions.push({
          text: I18n.text(seatTypeTitleKey),
          value: seatInfo.seatName,
          help: I18n.text(seatTypeSubtitleKey, {
            ownedProductsThatRequireCoreSeat: createOwnedProductString(ownedProductsThatRequireCoreSeat),
            seatLevel: formatSeatLevel(tier)
          })
        });
      } else {
        Raven.captureException(new Error(`getSeatSelectOptions: invalid I18n key for title:${seatTypeTitleKey} and/or subtitle:${seatTypeSubtitleKey}`), {
          extra: {
            seatType,
            tier
          }
        });
      }
    }
  }
  return seatSelectOptions.sort((a, b) => a.text.localeCompare(b.text));
};